import { useColorModeValue } from "@chakra-ui/react";

export function usePropertyModalTheme() {
	const borderColor = useColorModeValue("gray.200", "gray.700");
	const iconColor = useColorModeValue("blue.500", "blue.300");
	const sectionBg = useColorModeValue("gray.50", "gray.900");

	return { borderColor, iconColor, sectionBg };
}
